// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

// Define a service using a base URL and expected endpoints
export const mediacoreApi = createApi({
  reducerPath: "mediacoreApi",
  baseQuery: fetchBaseQuery({ baseUrl: (process.env.GATSBY_APISERVER || "https://mediacore.app/api") }),
  // baseQuery: fetchBaseQuery({ baseUrl: "https://mediacore.app/api/" }),
  endpoints: () => ({
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints